import User from "./User";
import HttpClient from "../HttpClient";
import Api from "../Api";

/**
 * Static API class.
 * @author Kacper Faber
 * @since 0.1.0
 */
class UserApi {
    /**
     * Get current authenticated user.
     * @author Kacper Faber
     * @since 0.1.0
     * @example
     * UserApi.me()
     * .then(user => {}) // user authenticated
     * .catch() // User is not authenticated.
     */
    static me(): Promise<User> {
        const url = Api.getUrl('/api/me/');
        return HttpClient.get<User>(url, {});
    }
}

export default UserApi;